import config from '../../config.js';
import products from '../../utils/products.js';
import fieldUtils from '../../utils/step.fields.utils.js';
//todo change labels

const claims = (driver, n) => {
    const result = [
        {...fieldUtils.claim_x_type(driver, n)},
    ];

    if (n < config[products.van].claims) {
        result.push({
            ...fieldUtils.claim_x_more(driver, n),
            children: claims(driver, n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};

const step_schema_school = [
    //source
    //Vehicle
    {
        key: 'vrm'
    },
    {
        key: 'make',
        required: true,
        skip_question: true,

    },
    {
        key: 'model',
        skip_question: true,
    },
    {
        key: 'year',
        required: true,
        skip_question: true,
    },
    {
        key: 'value'
    },
    {
        key: 'personal_miles'
    },
    {
        key: 'electric'
    },
    {
        key: 'vehicle_dual_control'
    },
    {
        key: 'pdi_cover'
    },
    {
        key: 'adi_cover'
    },
    //Driver
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'telephone'
    },
    {
        key: 'email'
    },
    {
        key: 'date_of_birth'
    },
    {
        key: 'postcode'
    },
    {
        key: 'address1',
        skip_question: true,
    },
    {
        key: 'address2',
        skip_question: true,
    },
    {
        key: 'address3',
        skip_question: true,
    },
    {
        key: 'address4',
        skip_question: true,
    },
    {
        key: 'city',
        skip_question: true,
    },
    {
        key: 'uk_since',
        children: [
            {
                key: 'uk_since_date',
                required_if: parent_value => parent_value === false
            },
        ],
    },
    {
        key: 'has_claims_more',
        children: claims('Proposer\'s', 0),
        required_children: value => value === true
    },
    //policy
    {
        key: 'cover_date'
    },
    {
        key: 'marketing',
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'}
        ]
    },
    {
        key: 'end',
    },
];
export default step_schema_school;
